import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';
import { IbaseService } from 'src/app/@shared/base-service/ibase-service';
import { MessageService } from 'src/app/@shared/message/message.service';
import { api } from 'src/app/@shared/services/api';
import { CommonService } from 'src/app/@shared/services/common.service';
import { WebserviceService } from 'src/app/@shared/services/webservice.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-update-profile',
  templateUrl: './update-profile.component.html',
  styleUrls: ['./update-profile.component.css']
})
export class UpdateProfileComponent implements OnInit {
  public api = api;
  public env = environment;
  public data: any;
  private subs: Subscription[] = [];
  @Input() updateProfileId: any;
  @Output() closeModal = new EventEmitter();
  formData!: FormGroup;
  public eventTypes: any[] = [];

  constructor(public service: WebserviceService,
    private _message: MessageService,
    private fb: FormBuilder,
    private _common: CommonService) {
    this.eventTypes = (localStorage.getItem(`${this.env.panel}menu`)) ? JSON.parse(localStorage.getItem(`${this.env.panel}menu`) as any) : [];
  }

  ngOnInit(): void {
    this.formData = this.fb.group({
      name: ['', Validators.required],
      // min_cricket_partnership: ['', Validators.required],
      // min_football_partnership: ['', Validators.required],
      // min_tennis_partnership: ['', Validators.required],
      // min_greyhound_partnership: ['', Validators.required],
      // min_horse_partnership: ['', Validators.required],
      // min_casino1_partnership: ['', Validators.required],
      // min_casino_i_partnership: ['', Validators.required],
    })
    // if (this.updateProfileId) {
    //   console.log(5555);
      
    //   this.getData(this.updateProfileId);
    // }
  }

  getServices(): IbaseService<any> {
    return this.service;
  }

  getData(id: any) {
    const sub1 = this.getServices().Get(`${this.env.baseUrl + this.api.user}/${id + this.api.getEditProfile}`).subscribe(
      (res) => {
        if (res.status == true) {
          this.formData.patchValue({
            name: res?.data[0]?.user?.name,
            // min_cricket_partnership: (res?.data[0]?.partnership_details?.min_cricket_partnership != null) ? res?.data[0]?.partnership_details?.min_cricket_partnership : 0,
            // min_football_partnership: (res?.data[0]?.partnership_details?.min_football_partnership != null) ? res?.data[0]?.partnership_details?.min_football_partnership : 0,
            // min_tennis_partnership: (res?.data[0]?.partnership_details?.min_tennis_partnership != null) ? res?.data[0]?.partnership_details?.min_tennis_partnership : 0,
            // min_greyhound_partnership: (res?.data[0]?.partnership_details?.min_greyhound_partnership != null) ? res?.data[0]?.partnership_details?.min_greyhound_partnership : 0,
            // min_horse_partnership: (res?.data[0]?.partnership_details?.min_horse_partnership != null) ? res?.data[0]?.partnership_details?.min_horse_partnership : 0,
            // min_casino1_partnership: (res?.data[0]?.partnership_details?.min_casino1_partnership != null) ? res?.data[0]?.partnership_details?.min_casino1_partnership : 0,
            // min_casino_i_partnership: (res?.data[0]?.partnership_details?.min_casino_i_partnership != null) ? res?.data[0]?.partnership_details?.min_casino_i_partnership : 0,
          })
          this.data = res.data;
          console.log(this.formData.value);

        } else {
          this._common.checkForForceChangePassword(res);
        }
      },
      (err) => {
        console.log(err);
      });
    this.subs.push(sub1)
  }

  submit = false;
  onSubmit() {
    this.submit = true;
    const sub2 = this.getServices().Post(`${this.env.baseUrl + this.api.user}/${this.updateProfileId + this.api.updateProfile}`, this._common.JSON_to_formData(this.formData.value)).subscribe(
      (res) => {
        if (res.status == true) {
          this._message.succmessage(res?.data?.message)
        } else {
          if (res.error.code == 1003) {
            this._common.checkForForceChangePassword(res);
          } else {
            this._message.errmessage(res?.error?.message);
          }        }
        this.submit = false
        this.closeModal.emit({status:true, key:'ep'});
      },
      (err) => {
        console.log(err);
      });
    this.subs.push(sub2)
  }
  cancel() {
    this.closeModal.emit({status:false, key:'ep'});
    // this._common.back();
  }

  trackByIndex(index: number, obj: any): any {
    return index;
  }

  ngOnChanges() {
    if (this.updateProfileId) {      
      // this.uId = this.actRoute.snapshot.paramMap.get('uid');
      this.getData(this.updateProfileId);
    }

  }

  ngOnDestroy() {
    this.subs.forEach((s) => s.unsubscribe());
  }

}
